import { Module } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { SendEncryptedOfferResponseDto } from '@/Application/XmlOffer/SendEncryptedOfferResponseDto'

export const state: AuctionState = {
  lastWizardStep: 1,
  offers: [],
  resultPost: new SendEncryptedOfferResponseDto('', [])
}

const namespaced = true

export const auctionb: Module<AuctionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
